<template>
  <iconMail v-if="name === 'mail'" />
  <iconPassword v-else-if="name === 'password'"/>
  <iconEye v-else-if="name === 'eye'"/>
  <iconOpenEye v-else-if="name === 'open-eye'"/>
  <iconArrowCircle v-else-if="name === 'arrow-circle'"/>
  <iconEnter v-else-if="name === 'enter'"/>
  <iconExit v-else-if="name === 'exit'"/>
  <iconCup v-else-if="name === 'cup'"/>
  <IconWatch v-else-if="name === 'watch'"/>
  <iconArrow v-else-if="name === 'arrow'"/>
  <iconChevronBot v-else-if="name === 'chevron-bot'"/>
  <IconChevronLeft v-else-if="name === 'chevron-left'"/>
  <iconChevronDouble v-else-if="name === 'chevron-double'"/>
  <iconChevronCircleBottom v-else-if="name === 'chevron-circle-bottom'"/>
  <iconChecked v-else-if="name === 'checked'"/>
  <iconCheckedGreen v-else-if="name === 'checked-green'"/>
  <iconCross v-else-if="name === 'cross'"/>
  <IconCrossDark v-else-if="name === 'cross-dark'"/>
  <iconInfo v-else-if="name === 'info'"/>
  <iconBigCross v-else-if="name === 'big-cross'"/>
  <iconVacation v-else-if="name === 'vacation'"/>
  <iconSearch v-else-if="name === 'search'"/>
  <iconTree v-else-if="name === 'tri'"/>
  <iconInfoCircleDark v-else-if="name === 'info-circle-dark'"/>
  <iconInfoCircle v-else-if="name === 'info-circle'"/>
  <IconPencil v-else-if="name === 'pencil'"/>
  <IconEditPencil v-else-if="name === 'pencil-edit'"/>
  <IconChevronDown v-else-if="name === 'chevron-down'"/>
  <IconPrint v-else-if="name === 'print'"/>
  <IconDuplicate v-else-if="name === 'duplicate'"/>
  <IconKebabMenu v-else-if="name === 'kebab-menu'"/>
  <IconCopy v-else-if="name === 'copy'"/>
  <IconCrossRed v-else-if="name === 'cross-red'"/>
  <IconArrowSmall v-else-if="name === 'arrow-sm'"/>
  <IconBurgerMenu v-else-if="name === 'burger-menu'"/>
  <iconWarnCircleRed v-else-if="name === 'warn-circle-red'"/>
  <IconCalendar v-else-if="name === 'calendar'"/>
  <IconCalendarGrey v-else-if="name === 'calendar-grey'"/>
  <IconExternalUser v-else-if="name === 'external-user'"/>
  <IconCircleArrowLeft v-else-if="name === 'circle-arrow-left'"/>
  <IconCircleArrowRight v-else-if="name === 'circle-arrow-right'"/>
  <iconPrintLg v-else-if="name === 'print-lg'"/>
  <iconSchedule v-else-if="name === 'schedule'"/>
  <iconClock v-else-if="name === 'clock'"/>
  <iconSettings v-else-if="name === 'settings'"/>
  <iconEnterBig v-else-if="name === 'enter-big'"/>
  <iconPhone v-else-if="name === 'phone'"/>
  <iconClear v-else-if="name === 'clear'"/>
  <iconChevronRight v-else-if="name === 'chevron-right'"/>
  <iconServiceBeru v-else-if="name === 'service-beru'"/>
  <iconUpdate v-else-if="name === 'update'"/>
  <IconChevronLeftCalendar v-else-if="name === 'chevron-left-calendar'"/>
  <IconChevronBlueDown v-else-if="name === 'chevron-blue-down'"/>
  <IconClockCircle v-else-if="name === 'clock-circle'"/>
  <IconDinnerCircle v-else-if="name === 'dinner-circle'"/>
  <IconProfiUser v-else-if="name === 'profi-user'"/>
</template>

<script lang="ts" setup>
import iconMail from '@/static/img/icons/iconMail.vue';
import iconPassword from '@/static/img/icons/iconPassword.vue';
import iconEye from '@/static/img/icons/iconEye.vue';
import iconOpenEye from '@/static/img/icons/iconOpenEye.vue';
import iconArrowCircle from '@/static/img/icons/iconArrowCircle.vue';
import iconEnter from '@/static/img/icons/iconEnter.vue';
import iconExit from '@/static/img/icons/iconExit.vue';
import iconCup from '@/static/img/icons/iconCup.vue';
import IconWatch from '@/static/img/icons/IconWatch.vue';
import iconArrow from '@/static/img/icons/iconArrow.vue';
import iconChevronBot from '@/static/img/icons/iconChevronBot.vue';
import IconChevronLeft from '@/static/img/icons/IconChevronLeft.vue';
import iconChevronCircleBottom from '@/static/img/icons/iconChevronCircleBottom.vue';
import iconChecked from '@/static/img/icons/iconChecked.vue';
import iconCheckedGreen from '@/static/img/icons/iconCheckedGreen.vue';
import iconCross from '@/static/img/icons/iconCross.vue';
import iconInfo from '@/static/img/icons/iconInfo.vue';
import iconChevronDouble from '@/static/img/icons/iconChevronDouble.vue';
import iconVacation from '@/static/img/icons/iconVacation.vue';
import iconSearch from '@/static/img/icons/iconSearch.vue';
import iconBigCross from '@/static/img/icons/iconBigCross.vue';
import iconTree from '@/static/img/icons/iconTree.vue';
import iconInfoCircleDark from '@/static/img/icons/iconInfoCircleDark.vue';
import iconInfoCircle from '@/static/img/icons/iconInfoCircle.vue';
import IconCrossDark from '@/static/img/icons/iconCrossDark.vue';
import IconPencil from '@/static/img/icons/iconPencil.vue';
import IconEditPencil from '@/static/img/icons/iconEditPencil.vue';
import IconChevronDown from '@/static/img/icons/iconChevronDown.vue';
import IconPrint from '@/static/img/icons/iconPrint.vue';
import IconDuplicate from '@/static/img/icons/iconDuplicate.vue';
import IconKebabMenu from '@/static/img/icons/iconKebabMenu.vue';
import IconCopy from '@/static/img/icons/iconCopy.vue';
import IconCrossRed from '@/static/img/icons/iconCrossRed.vue';
import IconArrowSmall from '@/static/img/icons/iconArrowSmall.vue';
import IconBurgerMenu from '@/static/img/icons/iconBurgerMenu.vue';
import iconWarnCircleRed from '@/static/img/icons/iconWarnCircleRed.vue';
import IconCalendar from '@/static/img/icons/iconCalendar.vue';
import IconCalendarGrey from '@/static/img/icons/iconCalendarGrey.vue';
import IconExternalUser from '@/static/img/icons/iconExternalUser.vue';
import IconCircleArrowLeft from '@/static/img/icons/iconCircleArrowLeft.vue';
import IconCircleArrowRight from '@/static/img/icons/iconCircleArrowRight.vue';
import iconPrintLg from '@/static/img/icons/iconPrintLg.vue';
import iconSchedule from '@/static/img/icons/iconSchedule.vue';
import iconClock from '@/static/img/icons/iconClock.vue';
import iconSettings from '@/static/img/icons/iconSettings.vue';
import iconEnterBig from '@/static/img/icons/iconEnterBig.vue';
import iconPhone from '@/static/img/icons/iconPhone.vue';
import iconClear from '@/static/img/icons/iconClear.vue';
import iconChevronRight from '@/static/img/icons/iconChevronRight.vue';
import iconServiceBeru from '@/static/img/icons/iconServiceBeru.vue';
import iconUpdate from '@/static/img/icons/iconUpdate.vue';
import IconChevronLeftCalendar from '@/static/img/icons/iconChevronLeftCalendar.vue';
import IconChevronBlueDown from '@/static/img/icons/iconChevronBlueDown.vue';
import IconClockCircle from '@/static/img/icons/iconClockCircle.vue';
import IconDinnerCircle from '@/static/img/icons/iconDinnerCircle.vue';
import IconProfiUser from '@/static/img/icons/iconProfiUser.vue';

defineProps<{
  name: string
}>();
</script>

<script lang="ts">
export default {
  name: 'vita-icon'
}
</script>
